import React, {Fragment, useEffect, useState} from "react";
import {Link, NavLink} from "react-router-dom";
import {Skeleton} from "@mui/material";
import LazyLoad from "react-lazy-load";


const Section_1 = (props) => {







    return (<Fragment>

        <style jsx>{`

        .box-cat-top-front {
        background-color: rgb(197, 234, 245);
        position: relative;
        left: 6%;
        width: 112%;
        top: -28px;
        padding-top: 63px;
        padding-bottom: 73px;
    }


        .box_scroll_horizontal {
        -webkit-box-pack: initial;
        align-items: normal;
        display: flex;
        flex: unset;
        flex-flow: row;
        margin-bottom: 6px;
        overflow-x: auto;
        overflow-y: hidden;
        padding-top: 2px;
        place-content: normal;
    }

        .item_cat_boxbk, .item_cat_boxbk a {
        align-content: center;
        align-items: center;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
    }

        .item_cat_boxbk {
        background-color: #ffffff;
        border-radius: 9px;
        height: 180px;
        margin-left: 1px;
        margin-right: 7px;
        max-height: 180px;
        min-width: 150px;
        padding-bottom: 3px;
        padding-top: 18px;
        width: 150px;
    }

        .image-cat-boxbk {
        width: 90px;
        position: relative;
        bottom: 18px;
        height: 90px;
    }

        .btn-cat-image-top {
        border: none;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

        .title-cat-boxbk {

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        height: 50px;
        font-size: 14px;

    }
        

        `}</style>

        <div className={"box-cat-top-front container_bk_fronts"}>
            <div style={{"display": "flex", "marginBottom": "46px"}}>
                <Link to={"/"}>صفحه اصلی</Link> / <span style={{"color": "#969fa2"}}>نیاز مندی ها</span>
            </div>
            <div className={"boxbk_cat_home"} style={{display: "block"}}>

                <div className="box_scroll_horizontal">

                    {

                        props.data_sub_category_box.length == 0 ? (
                            <React.Fragment>

                                <Skeleton variant="rectangular"
                                          style={{width: "100%", height: "180px", borderRadius: "10px"}}/>

                            </React.Fragment>


                        ) : (


                            props.data_sub_category_box.map((item_post, index) => {

                                return (

                                    <div className="item_cat_boxbk">
                                        {
                                            <NavLink reloadDocument={true} to={"/requirements/" + String(item_post.id)}
                                                     className={"btn-cat-image-top"}>
                                                <LazyLoad threshold={0.95}>
                                                    <img className="image-cat-boxbk" src={item_post.image_src}/>
                                                </LazyLoad>
                                                <span className={"title-cat-boxbk"}>{item_post.name}</span>
                                            </NavLink>

                                        }
                                        <span></span>

                                    </div>

                                );

                            })

                        )
                    }

                </div>

            </div>


        </div>


    </Fragment>);
}

export default Section_1;
